import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import {wagmiClient, ethereumClient} from "./config/wagmiClient";
import {WagmiConfig} from "wagmi";
import {Web3Modal} from "@web3modal/react";

// var CryptoJS = require("crypto-js");
// const bytes = CryptoJS.AES.decrypt(APP_ID, S_KEY);
// const APP_ID_DECRYPTED = bytes.toString(CryptoJS.enc.Utf8);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<WagmiConfig client={wagmiClient}>
			<App />
		</WagmiConfig>

		<Web3Modal
			projectId={process.env.REACT_APP_WEB3_PROJECT_ID}
			ethereumClient={ethereumClient}
		/>
	</React.StrictMode>
);
